export const motorProductEndpoints = (builder) => ({
    getMotorProducts: builder.query({
        query: (args = {}) => {
            const {
                pageNumber = 1,
                pageSize = 10,
                searchTerm,
                searchValue,
                sortField,
                sortOrder,
            } = args;

            const params = {
                pageNumber,
                pageSize,
            };

            if (searchTerm) params.searchTerm = searchTerm;
            if (searchValue) params.searchValue = searchValue;
            if (sortField) params.sortField = sortField;
            if (sortOrder) params.sortOrder = sortOrder;

            return {
                url: '/MotorProduct/MotorProductMaster',
                method: 'POST',
                body: params,
            };
        },
        providesTags: ['MotorProduct'],
    }),

    getMotorProductById: builder.query({
        query: (id) => `/MotorProduct/get-motor-product/${id}`,
        providesTags: (result, error, id) => [{ type: 'MotorProduct', id }],
    }),

    saveMotorProduct: builder.mutation({
        query: (data) => ({
            url: '/MotorProduct/SaveMotorProductMaster',
            method: 'POST',
            body: data,
        }),
        invalidatesTags: ['MotorProduct'],
    }),

    updateMotorProduct: builder.mutation({
        query: ({ id, data }) => ({
            url: `/MotorProduct/SaveMotorProductMaster`,
            method: 'POST',
            body: data,
        }),
        invalidatesTags: (result, error, { id }) => [
            { type: 'MotorProduct', id },
            'MotorProduct'
        ],
    }),

    deleteMotorProduct: builder.mutation({
        query: (id) => ({
            url: `/MotorProduct/delete-motor-product/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['MotorProduct'],
    }),

    bulkDeleteMotorProduct: builder.mutation({
        query: (ids) => ({
            url: "/MotorProduct/bulk-delete-motor-product",
            method: "POST",
            body: { ids },
        }),
        invalidatesTags: ['MotorProduct'],
    }),
});
